<template>
  <div class="doomyogaregister doomyoga-auth-container h-100">
    <div class="h-100">
      <div class="row h-100 m-0">
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 my-auto">
          <Register titleH2="Welcome To Do.OmYoga!" 
          welcomeHeader="Tell us a bit about you"
          client_name="DY" clientLink="doom_yoga" />
        </div>
        <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 my-5">
          <div class="container my-3" id="doomYogaImdDiv">
            <img
              class="img-fluid mx-auto"
              id="doomYogaLoginImg"
              src="@/assets/images/doom-yoga/doom-yoga-login-image2.png"
              alt="doomyoga Logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/auth/Register";

export default {
  name: "DoOmYogaRegister",
  components: { Register },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit signup");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../css/doom-yoga-fonts.css";
@import "../css/doom-yoga-auth-styles.css";
@import "../css/doom-yoga-buttons-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/doom_yoga/auth/RegisterView.vue